import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { TermsConditionsPositionEnum } from "@core/enums/terms-conditions-position.enum";
import { parseRouteParamNumber } from "@core/utils/parse-route-param-number.util";
import { ManagementCourseTermsConditionsService } from "@shared/services/management-course-terms-conditions/management-course-terms-conditions.service";

export const StartCourseTermsConditionsGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean | UrlTree> => {
  const managementCourseTermsConditions: ManagementCourseTermsConditionsService = inject(
    ManagementCourseTermsConditionsService,
  );
  const router: Router = inject(Router);

  const courseId: number | null = parseRouteParamNumber(route, "courseId");
  const lessonId: number | null = parseRouteParamNumber(route, "lessonId");

  if (!courseId || courseId < 0) return of(router.createUrlTree(["/catalogue"]));

  if (!lessonId || lessonId < 0) return of(router.createUrlTree(["/course-details", courseId]));

  return managementCourseTermsConditions.runCourseTermsGuard$({
    courseId,
    termsPosition: TermsConditionsPositionEnum.START,
    route,
  });
};
